webpackJsonp([1],{

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = elementIsVisible;
function elementIsVisible(element) {
  return !!(element.offsetWidth || element.offsetHeight);
}

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./utils/element-is-visible.js
var element_is_visible = __webpack_require__(12);

// CONCATENATED MODULE: ./utils/camel-case.js
/**
 * Converts a string from dash or underscore separated to camelCase.
 *
 * @param  {String} str
 * @return {String}
 */
function camelCase(str) {
  // remove any dashes or underscores in the string, and grab the following character
  return str.replace(/[-_]+(\w?)/g, function (match, p1) {
    // uppercase the following letter
    return p1.toUpperCase();
  });
}
// CONCATENATED MODULE: ./utils/get-attributes.js
/**
 * Gets all the attributes set on an element, and returns them as an Object.
 *
 * @param  {Element} element
 * @return {Object}
 */
function getAttributes(element) {
  var attrs = {};

  // if element is empty, or not ELEMENT_NODE, eject
  if (!element || element.nodeType !== 1) return attrs;

  // grab all the attributes off the element
  var map = element.attributes;

  // if there are no attributes, eject
  if (map.length === 0) return attrs;

  // loop through the attributes and build the object
  for (var i = 0; i < map.length; i++) {
    attrs[map[i].name] = map[i].value;
  }

  return attrs;
}
// CONCATENATED MODULE: ./utils/get-matching-attributes.js



/**
 * Searches an element's attributes and returns an Object of all the ones that
 * begin with a specified prefix. Each matching attribute name is returned
 * without the prefix, with the remainder converted to camelCase.
 *
 * @param  {Element} element
 * @param  {String} prefix
 * @return {Object}
 */
function getMatchingAttributes(element, prefix) {
  // get all the attributes on the element
  var attributes = getAttributes(element);
  var fields = {};

  // loop through the keys of the attributes
  Object.keys(attributes).forEach(function (key) {
    // continue if the key begins with supplied prefix
    if (key.substr(0, prefix.length) === prefix) {
      // grab the value associated with the original key
      var value = attributes[key];

      // slice off the prefix and camelCase what is left
      var field = camelCase(key.slice(prefix.length));

      fields[field] = value;
    }
  });

  return fields;
}
// CONCATENATED MODULE: ./utils/load-script.js
/**
 * A helper for asynchronously loading scripts.
 *
 * Provides a callback interface for passing a function that will only be called
 * if the script is successfully added to the page.
 *
 * @private
 * @param {String} url The URL for the script to be loaded.
 * @param {Function} [cb] A function to be called once the script successfully
 * loads. Not required.
 * @returns {void}
 * @example
 *
 * loadScript('backup.js', function () {
 *   // anything that depends on that script loading
 * });
 */
function loadScript(url, cb) {
  // create the `script` element
  var script = document.createElement('script');

  // set its URL
  script.src = url;

  // should always be async
  script.async = true;

  // if there is a supplied callback, add it to `onload`
  if (cb) script.onload = cb;

  // attach the script to the document body
  document.body.appendChild(script);
}

/* harmony default export */ var load_script = (loadScript);
// EXTERNAL MODULE: ./utils/scroll-observer.js
var scroll_observer = __webpack_require__(2);

// EXTERNAL MODULE: ./utils/select-all.js
var select_all = __webpack_require__(3);

// CONCATENATED MODULE: ./utils/unique-id.js
/**
 * Counter used by {uniqueId} to iterate.
 * @private
 * @type {Number}
 */
var idCounter = 0;

/**
 * Generates identifiers unique to a single browser session. Each time it runs,
 * the integer at the end of the return value will increment.
 *
 * Borrowed from underscore.js: http://underscorejs.org/#uniqueId
 *
 * @param  {String} [prefix] Optional prefix for identifier
 * @return {String}
 * @example
 *
 * var identifier = uniqueId();
 * // returns '1'
 *
 * var prefixedIdentifier = uniqueId('label-');
 * // returns 'label-2'
 */
function uniqueId(prefix) {
  var id = ++idCounter + '';
  return prefix ? prefix + id : id;
}
// CONCATENATED MODULE: ./utils/ad-loader.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var ad_loader_AdLoader = function () {
  function AdLoader() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$adFields = _ref.adFields,
        adFields = _ref$adFields === undefined ? { adUnit: '/5805113/basic', dimensions: [300, 250] } : _ref$adFields,
        _ref$attributePrefix = _ref.attributePrefix,
        attributePrefix = _ref$attributePrefix === undefined ? 'dv-gpt-' : _ref$attributePrefix,
        _ref$gptSrc = _ref.gptSrc,
        gptSrc = _ref$gptSrc === undefined ? 'https://www.googletagservices.com/tag/js/gpt.js' : _ref$gptSrc,
        _ref$idPrefix = _ref.idPrefix,
        idPrefix = _ref$idPrefix === undefined ? 'dv-gpt-' : _ref$idPrefix,
        _ref$scrollObserver = _ref.scrollObserver,
        scrollObserver = _ref$scrollObserver === undefined ? new scroll_observer["a" /* default */]() : _ref$scrollObserver,
        _ref$selector = _ref.selector,
        selector = _ref$selector === undefined ? '.dv-gpt-ad' : _ref$selector,
        _ref$targetingKey = _ref.targetingKey,
        targetingKey = _ref$targetingKey === undefined ? 'tribpedia' : _ref$targetingKey,
        targetingValue = _ref.targetingValue;

    _classCallCheck(this, AdLoader);

    this.adFields = adFields;
    this.attributePrefix = attributePrefix;
    this.gptSrc = gptSrc;
    this.idPrefix = idPrefix;
    this.scrollObserver = scrollObserver;
    this.targetingKey = targetingKey;
    this.targetingValue = targetingValue;

    this.initialized = false;
    this.adElements = Object(select_all["a" /* default */])(selector);
    this.adSlots = null;

    this.checkSlots = this.checkSlots.bind(this);
    this.createAds = this.createAds.bind(this);
    this.setupService = this.setupService.bind(this);
  }

  AdLoader.prototype.setupService = function setupService() {
    var _this = this;

    window.googletag.cmd.push(function () {
      var pubads = window.googletag.pubads();

      if (_this.targetingKey && _this.targetingValue) {
        pubads.setTargeting(_this.targetingKey, _this.targetingValue);
      }

      pubads.disableInitialLoad();
      window.googletag.enableServices();
    });
  };

  AdLoader.prototype.createAds = function createAds() {
    var _this2 = this;

    var _adFields = this.adFields,
        adUnit = _adFields.adUnit,
        dimensions = _adFields.dimensions;


    this.adSlots = this.adElements.map(function (element) {
      var matchingAttributes = getMatchingAttributes(element, _this2.attributePrefix);

      var options = Object.assign({}, { adUnit: adUnit, dimensions: dimensions }, matchingAttributes);

      var adElementId = uniqueId(_this2.idPrefix);
      element.setAttribute('id', adElementId);

      var gptAdUnit = window.googletag.defineSlot(options.adUnit, options.dimensions, adElementId);

      if (options.targetingKey && options.targetingValue) {
        gptAdUnit.setTargeting(options.targetingKey, options.targetingValue);
      }

      gptAdUnit.setCollapseEmptyDiv(true);
      gptAdUnit.addService(window.googletag.pubads());

      window.googletag.display(adElementId);

      return { slot: gptAdUnit, el: element, loaded: false };
    });

    this.checkSlots();
    this.scrollObserver.add(this.checkSlots);
  };

  AdLoader.prototype.checkSlots = function checkSlots() {
    var adSlots = this.adSlots;
    var threshold = 500;
    var clientHeight = document.documentElement.clientHeight;

    adSlots.forEach(function (ad, idx) {
      var slot = ad.slot;
      var element = ad.el;

      // the element is not visible at all, no need
      if (!Object(element_is_visible["a" /* default */])(element) || ad.loaded) return;

      var rect = element.getBoundingClientRect();

      var visible = rect.top <= clientHeight + threshold && rect.bottom >= -threshold;

      if (visible) {
        window.googletag.pubads().refresh([slot]);
        ad.loaded = true;
      }
    });
  };

  AdLoader.prototype.init = function init() {
    var _this3 = this;

    if (this.initialized) return;

    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];

    load_script(this.gptSrc, function () {
      window.googletag.cmd.push(_this3.setupService, _this3.createAds);

      _this3.initialized = true;
    });
  };

  return AdLoader;
}();

/* harmony default export */ var ad_loader = __webpack_exports__["default"] = (ad_loader_AdLoader);

/***/ })

});


// WEBPACK FOOTER //
// adloader.d25643ba2a.chunk.js